import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import logo from '../../images/CERN_logo.svg';
import visitorImage from '../../images/icons/visitor.svg';
import { Base64Avatar } from '../Base64Avatar/Base64Avatar';

interface UserDetailsProps {
    firstName: string;
    lastName: string;
    orgUnit?: string;
    userPicture?: string;
    visitor?: boolean;
}

export const UserDetails: React.FC<UserDetailsProps> = ({
    firstName,
    lastName,
    orgUnit,
    userPicture,
    visitor = false,
}) => {
    return (
        <Box textAlign={'center'}>
            {userPicture && (
                <div className="flip-box-container" style={{ height: '8rem' }}>
                    <div className="flip-box-inner">
                        <div className="flip-box-avatar" style={{ background: 'transparent' }}>
                            <Base64Avatar
                                src={userPicture}
                                style={{
                                    border: '2px solid white',
                                    borderRadius: '0',
                                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
                                }}
                            />
                        </div>
                        <div className="flip-box-logo" style={{ background: 'transparent' }}>
                            <img className="image" src={logo} alt="Overlay" style={{ border: '2px solid white' }} />
                        </div>
                    </div>
                </div>
            )}
            {visitor && (
                <div className="flip-box-container" style={{ height: '8rem' }}>
                    <div className="flip-box-inner">
                        <div
                            className="flip-box-avatar"
                            style={{
                                border: '2px solid white',
                                backgroundImage: `url(${visitorImage})`,
                                backgroundPosition: 'center',
                                backgroundSize: 'cover',
                            }}
                        ></div>
                        <div className="flip-box-logo" style={{ background: 'transparent' }}>
                            <img className="image" src={logo} alt="Overlay" style={{ border: '2px solid white' }} />
                        </div>
                    </div>
                </div>
            )}
            <Typography id="username" variant="h6" sx={{ mt: 1, textAlign: 'center', fontWeight: 600 }}>
                {firstName} {lastName}
            </Typography>
            {orgUnit ? (
                <Typography id="username" variant={'body1'}>
                    {orgUnit}
                </Typography>
            ) : null}
        </Box>
    );
};
